<template>
  <div>
    <hr class="dashed mx4" style="width: unset" />
    <div class="tearing_circle left"></div>
    <div class="tearing_circle_cover left"></div>

    <div class="tearing_circle_right_wrapper">
      <div class="tearing_circle right"></div>
      <div class="tearing_circle_cover right"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tear-line',
};
</script>

<style lang="scss">
.tearing_circle {
  background: #f1f1f1;
  height: $size_tearing_circle;
  width: $size_tearing_circle;
  position: absolute;
  overflow: visible;
  z-index: 4;
  border-radius: 99px;
  margin-top: $tearing_circle_margin_top;

  &.left {
    margin-left: - $card_margin;
    box-shadow: inset -2px 0px 3px 1px rgba(0,0,0,0.1);
  }

  &.right {
    margin-left: - $card_margin;
    box-shadow: inset 2px 0px 3px 1px rgba(0,0,0,0.1);
  }
}

.tearing_circle_cover {
  position: absolute;
  height: $size_tearing_circle;
  background-color: #f1f1f1;
  z-index: 5;
  width: $card_margin;
  margin-top: $tearing_circle_margin_top;
  border-radius: 99px;

  &.left {
    margin-left: -12px;
  }

  &.right {
    margin-left: -2px;
  }
}

.tearing_circle_right_wrapper {
  float: right;
}
</style>
